export default "/fonts/vendor/@fortawesome/fontawesome-free/webfa-regular-400.eot?0747be4cba2f8600544f4f09645d971a";